import {NoteNode} from "../../model/node";
import {Link} from "react-router-dom";
import Folder from "../../icons/folder";
import File from "../../icons/file";

export default function NodeCard({node}: { node: NoteNode }) {
    return (
        <div className="flex space-x-1 mb-2 items-center">
            <NodeIcon node={node}/>
            <Link to={"/note/" + node.path}><span>{node.name}</span></Link>
        </div>
    );
}

function NodeIcon({node}: { node: NoteNode }) {
    return (<>
        {node.nodeType === "Directory" ? (
            <Folder/>
        ) : (
            <File/>
        )}
    </>);
}